<template>
  <v-sheet class="text-center py-16">
    <v-progress-circular indeterminate color="primary" size="48"></v-progress-circular>
  </v-sheet>
</template>
<script>
// 네이버 로그인은 로그인 화면에 단추가 없고 서버에 받는 곳(/api/test/naver)도 없다.
// 옛 코드는 가입 동의 화면(이용약관·개인정보·만 14세 확인)을 건너뛰고 바로 회원을 만들었으므로,
// 주소로 들어와도 아무도 가입시키지 않고 로그인 화면으로 돌려보낸다(10/19 처리방침 반영 조건).
const { loginPageWithState } = require("@/util/travelerAttribution")

export default {
  mounted() {
    this.$router.replace(loginPageWithState(this.$route.query.state))
  },
}
</script>
